import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = 18, readOnly = true, testId }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-1" data-testid={testId}>
      {stars.map((n) => {
        const filled = value >= n - 0.25;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange && onChange(n)}
            className={`${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform`}
            aria-label={`${n} stars`}
            data-testid={testId ? `${testId}-star-${n}` : undefined}
          >
            <Star
              size={size}
              className={filled ? "fill-amber-400 text-amber-400" : "text-gray-300"}
            />
          </button>
        );
      })}
    </div>
  );
}
